// @ts-check
import React from 'react';
/*
This is a HOC for routable components that that makes `props.params` available at `props.match.params`.

This enables us to upgrade our components to use the React Router v4 props while still using React Router v3.

In particular, this allows us to have shared components that work in both react router v3 and react router v4,
at least as far as `props.match.params` is concerned.

*/

const calculateNewProps = props => {
  return {
    ...props,
    match: {
      params: props.params,
    },
  };
};

const injectRouterMatchProps = component => {
  return props => React.createElement(component, calculateNewProps(props));
};

export { injectRouterMatchProps };
